import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError, map } from "rxjs/operators";
import { environment } from "@environments/environment";
import { User } from "@app/models";

@Injectable({ providedIn: "root" })
export class UserService {
  constructor(private http: HttpClient) {}

  loginUser(data) {
    let url = environment.scs_url_lh + `/portal/login`;
    return this.http.post<any>(url,data)
      .pipe(map(res => {
        return res;
      }));
      
  }

  getUserInfo(): Observable<any> {
    let cuUser = JSON.parse(localStorage.getItem("currentUser"));
    let productType = cuUser.partner.product_type;

    let url = `${environment.scs_url_lh}/portal/user/${cuUser.web_token}?product_type=${productType}`;
     return this.http.get<any>(url)
      .pipe(map((res: any) => {
        return res; 
      }));
  }

  updateUserInfo(data): Observable<any> {
    let url = `${environment.scs_url_lh}/portal/user/update/user_ifo`;
     return this.http.post<any>(url,data)
      .pipe(map((res: any) => {
        return res; 
      }));
  }

  forgotPassword(data): Observable<any> {
    let url = `${environment.scs_url_lh}/portal/user/password/reset`;
     return this.http.post<any>(url,data)
      .pipe(map((res: any) => {
        return res; 
      }));
  }


  updatePassword(data){
    let url = `${environment.scs_url_lh}/portal/user/password/reset`;
     return this.http.post<any>(url,data)
      .pipe(map((res: any) => {
        return res; 
      }))
  }

  // Error handling
  errorHandle(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
